import { StartingPoint } from '../ProfilePage';

export const getCompanyTrackingProps = (
  {
    id,
    name,
    screen,
    subType,
    step,
    startingPoint,
    selectedPlan,
  }: {
    id?: number;
    name?: string;
    screen: string;
    subType?: string;
    step?: string;
    startingPoint?: StartingPoint;
    selectedPlan?: string;
  },
  isSaasEvent?: boolean,
) => {
  return {
    ...(isSaasEvent ? { mp_place_id: id, mp_company_name: name } : { place_id: id, company_name: name }),
    screen_name: screen,
    company_subscription_type: subType,
    sign_up_step: step,
    sign_up_starting_point: startingPoint,
    selected_plan: selectedPlan,
  };
};
